<!--CC: simplified domain list for onboarding wizard, taken from plan-settings-domain.component.html-->
<div class="flex-column gap-3 f-1-0" style="overflow: auto;">

	<!--CC: loading state-->
	<div class="flex-column align-items-center justify-content-center f-1-0" *ngIf="loadingInProcess">
		<loader-c></loader-c>
	</div>

	<!--CC: add domain button-->
	<div class="flex-row" *ngIf="!loadingInProcess">
		<btn-c endIcon="far fa-plus" (action)="openAddDomain()">
			Add Domain
		</btn-c>
	</div>

	<!--CC: empty state-->
	<div class="flex-column align-items-center gap-2 py-4 text-muted" *ngIf="!loadingInProcess && !userDomains?.length">
		<i class="far fa-globe" style="font-size: 32px;"></i>
		<span>No domains found</span>
	</div>

	<!--CC: domain list-->
	<ng-container *ngIf="!loadingInProcess && userDomains?.length">
		<!--CC: domain cards-->
		<div class="flex-column gap-2">
			<div class="flex-column border rounded" *ngFor="let domainObj of userDomains">
				<!--CC: domain row — name, statuses, actions-->
				<div class="flex-row align-items-center gap-3 p-3">
					<!--CC: domain name and overall status-->
					<div class="flex-column gap-1 f-1-0">
						<div class="flex-row align-items-center gap-2">
							<i class="far fa-globe text-muted"></i>
							<span class="fw-bold">{{domainObj.domain}}</span>
							<i class="far fa-check-circle text-success" *ngIf="isAllVerified(domainObj)"
							   tooltip="All records verified"></i>
						</div>
						<!--CC: verification status chips-->
						<div class="flex-row gap-2">
							<span class="badge" [ngClass]="domainObj.verified ? 'bg-success' : 'bg-warning text-dark'">
								Identity: {{domainObj.verified ? 'Verified' : 'Unverified'}}
							</span>
							<span class="badge" [ngClass]="domainObj.dkim_verified ? 'bg-success' : 'bg-warning text-dark'">
								DKIM: {{domainObj.dkim_verified ? 'Verified' : 'Unverified'}}
							</span>
							<span class="badge" [ngClass]="domainObj.mail_from_verified ? 'bg-success' : 'bg-warning text-dark'">
								MAIL FROM: {{domainObj.mail_from_verified ? 'Verified' : 'Unverified'}}
							</span>
							<span class="badge" [ngClass]="domainObj.spf_verified ? 'bg-success' : 'bg-warning text-dark'">
								SPF: {{domainObj.spf_verified ? 'Verified' : 'Unverified'}}
							</span>
						</div>
					</div>

					<!--CC: action buttons-->
					<div class="flex-row align-items-center gap-2">
						<btn-c endIcon="far fa-bolt"
							   btnTooltip="Automatically configure DNS records with your DNS provider"
							   (action)="connectEntriDomain(domainObj)">
							Auto Verify
						</btn-c>
						<btn-c variant="text" endIcon="far fa-chevron-down"
							   btnTooltip="Show DNS records"
							   [ngStyle]="{'transform': domainObj.isExpanded ? 'rotate(180deg)' : 'none'}"
							   style="transition: transform 0.2s;"
							   (action)="toggleDnsRecords(domainObj)">
						</btn-c>
					</div>
				</div>

				<!--CC: expandable DNS records section, taken from plan-settings-domain.component.html-->
				<div class="flex-column gap-2 p-3 border-top" style="background: #fafafa;" *ngIf="domainObj.isExpanded">
					<!--CC: Identity card-->
					<div class="flex-column gap-2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 16px 20px; background: white;">
						<div class="flex-row justify-content-between align-items-center">
							<div class="flex-row align-items-center gap-1">
								<b>Identity</b>
								<i class="far fa-question-circle text-muted" style="font-weight: 400;" tooltip="Indicates whether emails can be sent on behalf of this domain"></i>
							</div>
							<div class="flex-row align-items-center gap-2">
								<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="domainObj.verified ? {'color': 'green'} : {'color': 'darkorange'}">{{domainObj.verified ? 'Verified' : 'Unverified'}}</span>
								<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainIdentityVerified(domainObj)"></btn-c>
							</div>
						</div>
						<table class="simpleDataTable w-100">
							<thead>
								<tr>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Value</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style="padding-left: 10px;">TXT</td>
									<td><a (click)="copyText('_amazonses');"><span class="copy-link">_amazonses</span></a></td>
									<td style="word-break: break-all;"><a (click)="copyText(domainObj.data?.verify_token);"><span class="copy-link">{{domainObj.data?.verify_token}}</span></a></td>
								</tr>
							</tbody>
						</table>
					</div>

					<!--CC: DKIM card-->
					<div class="flex-column gap-2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 16px 20px; background: white;">
						<div class="flex-row justify-content-between align-items-center">
							<div class="flex-row align-items-center gap-1">
								<b>DKIM</b>
								<i class="far fa-question-circle text-muted" style="font-weight: 400;" tooltip="Indicates whether emails sent on behalf of this domain will conform with the domain's DKIM policy"></i>
							</div>
							<div class="flex-row align-items-center gap-2">
								<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="domainObj.dkim_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{domainObj.dkim_verified ? 'Verified' : 'Unverified'}}</span>
								<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainDkimVerified(domainObj)"></btn-c>
							</div>
						</div>
						<table class="simpleDataTable w-100">
							<thead>
								<tr>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Pointer</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let dkim of domainObj.data?.dkim">
									<td style="padding-left: 10px;">CNAME</td>
									<td style="word-break: break-all;"><a (click)="copyText(dkim + '._domainkey');"><span class="copy-link">{{dkim}}._domainkey</span></a></td>
									<td style="word-break: break-all;"><a (click)="copyText(dkim + '.dkim.amazonses.com');"><span class="copy-link">{{dkim}}.dkim.amazonses.com</span></a></td>
								</tr>
							</tbody>
						</table>
					</div>

					<!--CC: MAIL FROM card-->
					<div class="flex-column gap-2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 16px 20px; background: white;" *ngIf="domainObj.data?.from_record">
						<div class="flex-row justify-content-between align-items-center">
							<div class="flex-row align-items-center gap-1">
								<b>MAIL FROM</b>
								<i class="far fa-question-circle text-muted" style="font-weight: 400;" tooltip="The emails you send will be marked as originating from your domain and bounce/feedback can reach back to you"></i>
							</div>
							<div class="flex-row align-items-center gap-2">
								<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="domainObj.mail_from_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{domainObj.mail_from_verified ? 'Verified' : 'Unverified'}}</span>
								<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainMailFromVerified(domainObj)"></btn-c>
							</div>
						</div>
						<table class="simpleDataTable w-100">
							<thead>
								<tr>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Value / Pointer</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Priority</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style="padding-left: 10px;">TXT</td>
									<td><a (click)="copyText('trustifi');"><span class="copy-link">trustifi</span></a></td>
									<td style="word-break: break-all;"><a (click)="copyText('v=spf1 include:amazonses.com ~all');"><span class="copy-link">v=spf1 include:amazonses.com ~all</span></a></td>
									<td></td>
								</tr>
								<tr>
									<td style="padding-left: 10px;">MX</td>
									<td><a (click)="copyText('trustifi');"><span class="copy-link">trustifi</span></a></td>
									<td style="word-break: break-all;"><a (click)="copyText('feedback-smtp.us-east-1.amazonses.com');"><span class="copy-link">feedback-smtp.us-east-1.amazonses.com</span></a></td>
									<td><a (click)="copyText('10');"><span class="copy-link">10</span></a></td>
								</tr>
							</tbody>
						</table>
					</div>

					<!--CC: SPF card-->
					<div class="flex-column gap-2" style="border: solid 1px #e3e4e4; border-radius: 6px; padding: 16px 20px; background: white;">
						<div class="flex-row justify-content-between align-items-center">
							<div class="flex-row align-items-center gap-1">
								<b>SPF</b>
								<i class="far fa-question-circle text-muted" style="font-weight: 400;" tooltip="Add include:_spf.trustifi.com to the existing SPF (TXT) record of the root domain, before the final -all / ~all"></i>
							</div>
							<div class="flex-row align-items-center gap-2">
								<span style="font-size: 0.85em; font-weight: 500;" [ngStyle]="domainObj.spf_verified ? {'color': 'green'} : {'color': 'darkorange'}">{{domainObj.spf_verified ? 'Verified' : 'Unverified'}}</span>
								<btn-c variant="text" endIcon="far fa-sync-alt" btnTooltip="Verify" (action)="isDomainSpfVerified(domainObj)"></btn-c>
							</div>
						</div>
						<table class="simpleDataTable w-100">
							<thead>
								<tr>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase; padding-left: 10px;">Type</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Host</th>
									<th style="font-size: 0.8em; color: grey; text-transform: uppercase;">Add to existing value</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td style="padding-left: 10px;">TXT</td>
									<td style="word-break: break-all;"><a (click)="copyText('@');"><span class="copy-link">@</span></a> <span class="text-muted" style="font-size: 0.85em;">(root: {{domainObj.domain}})</span></td>
									<td style="word-break: break-all;"><a (click)="copyText('include:_spf.trustifi.com');"><span class="copy-link">include:_spf.trustifi.com</span></a></td>
								</tr>
							</tbody>
						</table>
						<span class="text-muted" style="font-size: 0.85em;">Edit the SPF record that already exists on {{domainObj.domain}} (starts with "v=spf1") and insert the value before the final "-all" / "~all". Do not create a second SPF record.</span>
					</div>
				</div>
			</div>
		</div>
	</ng-container>

	<!--CC: add domain popup, taken from plan-settings-domain.component.html-->
	<popup-c class="bs-enabled" *ngIf="addDomainPopup?.show"
			 head="Add Domain" size="dynamic"
			 (closeCb)="addDomainPopup.show = false;"
			 (confirmCb)="addDomain()"
			 [buttons]="{cancel: 'Cancel', confirm: {text: 'Add Domain', disabled: addDomainPopup.applyInProcess || !addDomainPopup.domainName.length}}">
		<div class="flex-column f-1-0 gap-2" style="overflow: auto;">
			<p style="font-size: 14px;">Please fill in the domain name</p>

			<div class="align-items-center flex-row gap-3">
				<div>Domain:</div>
				<input type="text" placeholder="Domain's name (required)"
					   style="width: 330px;" [required]="true"
					   [(ngModel)]="addDomainPopup.domainName"
					   [ngStyle]="!addDomainPopup.domainName && addDomainPopup.errMsg ? {'border-color': 'red'} : {}"/>
			</div>
			<p>You will be asked to verify the DNS records that will be provided.</p>
			<checkbox class="transparent-box success-color"
					  [(model)]="addDomainPopup.autoVerify"
					  tooltipTxt="Automatically configure the required DNS records with your DNS provider after the domain is added">
				<span>Auto verify</span>
			</checkbox>
			<p class="text-danger" *ngIf="addDomainPopup.errMsg">{{addDomainPopup.errMsg}}</p>
		</div>
	</popup-c>
</div>
